import { Component, Input, Optional, Self, Inject } from '@angular/core';
import { NgControl, NG_VALIDATORS } from '@angular/forms';
import { FormControlBase } from '../../common/form-control-base/form-control-base';
import { PhoneValidator } from '../../validators/phone-validator';
import { TCM_FORM_CONFIG, TCMFormConfig } from '../../tcm-form-config';
import { MaskitoOptions, MaskitoMask } from '@maskito/core';

// Maskito mask patterns - arrays of RegExp for digits and strings for separators
const DEFAULT_US_MASK: MaskitoMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
const PHONE_MASK_PATTERNS = {
  US: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] as MaskitoMask,
  US_WITH_AREA: ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] as MaskitoMask,
  INTERNATIONAL: ['+', /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/] as MaskitoMask,
  SIMPLE: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] as MaskitoMask
}

// Keep string versions for legacy compatibility
const PHONE_MASKS = {
  US: '000-000-0000',
  US_WITH_AREA: '(000) 000-0000',
  INTERNATIONAL: '+0 000 000 0000',
  SIMPLE: '000-000-0000'
}
@Component({
    selector: 'waf-phone-input',
    templateUrl: './phone-input.component.html',
    inputs: ['label', 'disabled', 'hideValidationMessages', 'isReadonlyValue', 'placeholder', 'tabindex'],
    providers: [
        PhoneValidator,
        { provide: NG_VALIDATORS, useExisting: PhoneValidator, multi: true }
    ],
    standalone: false
})
export class PhoneInputComponent extends FormControlBase<string> {

  @Input() mask: string;

  @Input() maxlength: number;

  phoneMask: MaskitoMask = DEFAULT_US_MASK;
  phoneMaskOptions: MaskitoOptions = { mask: DEFAULT_US_MASK };

  get phoneValue(): string {
    return this.value;
  }

  set phoneValue(formattedVaue: string) {
    this.value = formattedVaue;
  }

  constructor(
    @Self() @Optional() protected override ngModel: NgControl,
    @Optional() @Inject(TCM_FORM_CONFIG) protected config: TCMFormConfig,
    protected phoneValidator: PhoneValidator,
  ) {
    super('waf-phone-input', ngModel);
  }

  override onInit() {
    super.onInit();
    this.setupMask();
  }

  private setupMask() {
    if(this.mask) {
      this.phoneMask = this.convertStringToMask(this.mask);
    } else if (this.config && this.config.phoneMask) {
      this.phoneMask = this.convertLegacyMask(this.config.phoneMask)
    } else {
      this.phoneMask = DEFAULT_US_MASK
    }
    this.phoneMaskOptions = {
      mask: this.phoneMask
    };
  }

  private convertStringToMask(maskString: string): MaskitoMask {
    // Convert predefined string patterns to MaskitoMask arrays
    switch(maskString) {
      case '000-000-0000':
        return PHONE_MASK_PATTERNS.US;
      case '(000) 000-0000':
        return PHONE_MASK_PATTERNS.US_WITH_AREA;
      case '+0 000 000 0000':
        return PHONE_MASK_PATTERNS.INTERNATIONAL;
      default:
        // Convert generic string pattern to mask array
        return maskString.split('').map(char => {
          if (char === '0') {
            return /\d/;
          }
          return char;
        }) as MaskitoMask;
    }
  }

  private convertLegacyMask(legacyMask: any): MaskitoMask {
    if(Array.isArray(legacyMask)) {
      // Already in correct format for MaskitoMask
      return legacyMask as MaskitoMask;
    }

    if(typeof legacyMask === 'string') {
      return this.convertStringToMask(legacyMask);
    }

    return DEFAULT_US_MASK;
  }

  static getPhoneMasks() {
    return PHONE_MASKS;
  }
}
